import ProgramAssignmentModal from './ProgramAssignmentModal';

export default ProgramAssignmentModal;
